export default {
	getRoute(state) {
		return state.route;
	},
};
